import React from 'react';


const NudeNewsContactPage = () => (
  <div className="content">
    <div className="container">
      <div
        className="container contact-container"
        id="contactIndex"
      >
        <h1>Contact Nude News</h1>
        <p className="lead">
          <strong>
            We would love to hear from you. Please fill
            out the form below with your questions,
            comments, content requests or to report an
            issue and we will get back to you as soon as
            possible.
          </strong>
        </p>
        <p>
          <strong>
            Please note that if you are experiencing
            difficulties logging into www.nudenews.com
            please try the following before contacting
            customer support:
          </strong>
        </p>
        <p />
        <ol>
          <li>
            Clear out your cache and delete all current
            cookies.
          </li>
          <li>Clear out your files and your history</li>
          <li>
            Reset your cookies to be at their lowest
            settings
          </li>
          <li>
            Turn off pop-up ad blocking software for the
            site domain
          </li>
          <li>
            Close out your browser and open a new one.
          </li>
        </ol>
        Naked News Support Department responds to ALL
        requests for help. However, some Internet Service
        Providers (ISPs) such as AOL and RoadRunner, as well
        as some email sites, may block or divert our replies
        to you because the word "Naked" sets off their spam
        detector programs.
        <br />
        <br />
        If you do not get a timely reply to your question,
        please check your email program's spambox, trash
        box, and anywhere else it might have been diverted.
        You may also want to contact your ISP's email
        administrator and request that they make sure that
        our email is allowed to get to you.
        <br />
        <br />
        For the reasons above, we have set up an external
        email address to communicate with affected members.
        If you do not receive a timely response to your
        question, please try emailing us at{' '}
        <a href="mailto:support@nakednews.com">
          support@nakednews.com
        </a>{' '}
        and we will respond to you from there.
        <br />
        <br />
        We do not spam our members or anyone else, and some
        Naked News fans have missed important Support
        messages because of these actions.
        <br />
        <br />
        <p>
          Please check our <a href="/faq">FAQ</a> to see
          if your question is answered there
        </p>
        {/* <form
                    className="form-horizontal"
                    action="/contact"
                    acceptCharset="UTF-8"
                    method="post"
                >
                    <input
                        name="utf8"
                        type="hidden"
                        defaultValue="✓"
                    />
                    <input
                        name="authenticity_token"
                        type="hidden"
                        defaultValue="lrSP2sPQbf4aH4Pp1njqvgOSFqTUwbnJvq0kGmrMzjAnN+KnenUnA1PTkVociQhHLuilFOMhVvSY2uaXvnTtJw=="
                    />
                    <div className="form-group">
                        <label htmlFor="name">Name</label>
                        <input
                            type="text"
                            name="customer_ticket[user_name]"
                            id="customer_ticket_user_name"
                            defaultValue
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="text"
                            name="customer_ticket[user_email]"
                            id="customer_ticket_user_email"
                            defaultValue
                            required="required"
                            pattern="[^@]+@[^@]+\.[a-zA-Z]{2,6}"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="category">Category</label>
                        <select
                            name="customer_ticket[category]"
                            id="customer_ticket_category"
                            className="form-control"
                            onchange="this.value == 'Other' ? document.getElementById('other_support_title').style.display='block' : document.getElementById('other_support_title').style.display='none';"
                        >
                            <option value="Question/Comment About the Show">
                                Question/Comment About the Show
                            </option>
                            <option value="Technical Problem">
                                Technical Problem
                            </option>
                            <option value="Billing Question">
                                Billing Question
                            </option>
                            <option value="Unable to Access the Site">
                                Unable to Access the Site
                            </option>
                            <option value="Cancel">Cancel</option>
                            <option value="Other">Other</option>
                        </select>
                    </div>
                    <div
                        className="form-group"
                        id="other_support_title"
                        style={{ display: 'none' }}
                    >
                        <label htmlFor="custom_category">
                            Custom Category
                        </label>
                        <input
                            type="text"
                            name="customer_ticket[custom_category]"
                            id="customer_ticket_custom_category"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="description">
                            Description
                        </label>
                        <textarea
                            name="customer_ticket[description]"
                            id="customer_ticket_description"
                            rows={5}
                            className="form-control"
                            defaultValue={''}
                        />
                    </div>
                    <div className="hide">
                        <input
                            type="text"
                            name="browser_info[browser_OS]"
                            id="browser_info_browser_OS"
                            defaultValue="5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/70.0.3538.110 Chrome/70.0.3538.110 Safari/537.36"
                        />
                        <input
                            type="text"
                            name="browser_info[flash]"
                            id="browser_info_flash"
                        />
                        <input
                            type="text"
                            name="browser_info[video_support]"
                            id="browser_info_video_support"
                            defaultValue="true"
                        />
                        <input
                            type="text"
                            name="browser_info[h264_support]"
                            id="browser_info_h264_support"
                            defaultValue="probably"
                        />
                        <input
                            type="text"
                            name="browser_info[cookies]"
                            id="browser_info_cookies"
                            defaultValue="true"
                        />
                        <input
                            type="text"
                            name="browser_info[incognito]"
                            id="browser_info_incognito"
                            defaultValue="false"
                        />
                        <input
                            type="text"
                            name="super_secret"
                            id="super-secret"
                            defaultValue="agh2408daohg"
                        />
                    </div>
                    <input
                        type="submit"
                        name="commit"
                        defaultValue="Submit"
                        className="btn btn-primary btn-lg"
                    />
                </form> */}
      </div>
      <div className="well">
        <p>
          Experiencing access issues? Our customer service
          team is here to assist you! Please provide us
          with at least TWO of the following items. This
          will aid in our ability to quickly locate your
          account and have you surfing for your favorite
          actors in no time:
        </p>
        <ol>
          <li>
            Name of the billing company that is charging
            you for this site
          </li>
          <li>
            Subscription number or Membership ID number
          </li>
          <li>Name as it appears on credit card</li>
          <li>
            The last four digits of your credit card
          </li>
          <li>A copy of your purchase receipt</li>
        </ol>
        <p>
          Thank you,
          <br />
          Customer Service
        </p>
      </div>
    </div>
  </div>
);

export default NudeNewsContactPage;
